import { useContext, useState } from 'react'
import { LuMoreVertical } from 'react-icons/lu'
import { Button, Popover, Popconfirm } from 'antd'
import useManageUSer from './useManageTicket'

const Cell: React.FC<{ record: any }> = ({ record }) => {
  const [popOpen, setPopOpen] = useState(false)
  const { onClick, isLoading } = useManageUSer(setPopOpen)
  const disabled = record.status === 'Cerrado'

  const style = { display: 'flex', alignItems: 'center', justifyContent: 'end' }

  const props = {
    container: {
      style,
      onClick: e => {
        e.stopPropagation()
        !disabled && setPopOpen(true)
      }
    },
    popover: {
      arrow: false,
      open: popOpen,
      destroyTooltipOnHide: true,
      placement: 'left' as 'left',
      trigger: 'click' as 'click',
      onOpenChange: val => !val && setPopOpen(false),
      content: (
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>

          <li>
            <Popconfirm
              title="Cerrar ticket"
              description="¿Está seguro que desea cerrar este ticket? Una vez cerrado, no podrá reabrirse nuevamente"
              onConfirm={() => !disabled && onClick(record)}
              okText="Cerrar"
              cancelText="Cancelar"
              okButtonProps={{
                danger: true
              }}
              placement="left"
            >
              <Button
                type="text"
                loading={isLoading}
                style={{ width: '100%', textAlign: 'start' }}
              >
                Cerrar ticket
              </Button>
            </Popconfirm>
          </li>

        </ul>
      )
    }
  }

  return (
    <div {...props.container}>
      <Popover {...props.popover} >
        <div style={style}>
          <LuMoreVertical style={{ cursor: disabled ? undefined : 'pointer' }} color={disabled ? '#999' : undefined} />
        </div>
      </Popover>
    </div>
  )
}

const MoreOptions: React.FC = (id: string, record) => {
  if (id === '' || !id) return null

  return <Cell record={record} />
}

export default MoreOptions
